export default "__VITE_ASSET__Cw4anrin__";